<template>
  <div class="content">
    <div v-if="$store.state.utils.configuration.enableNewProductMissingModal">
      <div class="new-modal-error-icon">!</div>
      <h2 class="new-modal-title">{{ translations.productMissing404 }}</h2>
      <p class="new-modal-description">
        {{ translations.productMissingText }}
      </p>
    </div>
    <h5 class="text-center subheader" v-else >
      {{ translations.productMissingDesc }}
    </h5>
  </div>
</template>

<script>
export default {
  name: "ProductMissingModal",
  computed: {
    translations(){
      return this.$store.state.translations.data;
    }
  },
};
</script>
